module.exports = "<p>\n  footer works!\n</p>\n"


//////////////////
// WEBPACK FOOTER
// ./src/app/components/shared/footer/footer.component.html
// module id = ./src/app/components/shared/footer/footer.component.html
// module chunks = main